import React from "react";
import { Chip, Stack, Switch, Typography } from "@mui/material";

import {
  HubBackButton,
  HubButton,
  HubHookFormSwitch,
  InputLabel,
  EmployeeScanIndicator,
} from "../../components";
import { useEmployeeScanContext } from "../../hooks/contexts/EmployeeScanContextProvider";
import { useScannerHelper } from "../../helpers/scannerHelper";

import { StyledTitleStack } from "../PartDetails/styles";
import { JOB_STATUSES, WORK_STATUS } from "../../constants";
import { StyledSelect } from "./styles";
import { useFormContext } from "react-hook-form";
import { handleDownloadPdf } from "../../helpers";
import { usePutPrintWorkOrder } from "../../hooks";

export const StatusChip = ({ status }) => {
  const chipProps = { variant: "colorTag", sx: { fontSize: 10 } };

  let props = { label: "Not Started", flow: "grey", ...chipProps };
  switch (status) {
    case JOB_STATUSES.IN_PROGRESS:
      props = { label: "In Progress", flow: "green", ...chipProps };
      break;
    case JOB_STATUSES.COMPLETE:
      props = { label: "Completed", flow: "blue", ...chipProps };
    default:
      break;
  }
  return <Chip {...props} />;
};

const WorkOrderBar = ({
  workOrder,
  status,
  state = 1,
  showCompleted = false,
  onCloseWorkOrder = () => {},
  setShowCompleted = () => {},
}) => {
  const { mutate: markPrinted } = usePutPrintWorkOrder();
  const { formState } = useFormContext();
  const isDirty = formState?.isDirty;
  
  // Get scan context
  const {
    scannedEmployee,
    isScanned,
    clearSession,
    handleEmployeeScan,
    shouldShowScan,
  } = useEmployeeScanContext();

  useScannerHelper(handleEmployeeScan, [handleEmployeeScan]);

  const handleDownload = async () => {
    const status = await handleDownloadPdf({
      id: "traverler-sheet",
      name: workOrder,
    });
    if (status) markPrinted(workOrder);
  };

  return (
    <StyledTitleStack>
      <Stack direction="row" gap="10px" alignItems="center">
        <HubBackButton />
        <Typography variant="caption">{workOrder}</Typography>
        <StatusChip status={status} />
      </Stack>
      <Stack direction="row" gap="10px" alignItems="center">
        <EmployeeScanIndicator
          scannedEmployee={scannedEmployee}
          isScanned={isScanned}
          onClear={clearSession}
          onEmployeeScan={handleEmployeeScan}
          shouldShow={shouldShowScan}
        />
        <Stack
          direction="row"
          gap="10px"
          alignItems="center"
          justifyContent="center"
        >
          <InputLabel label="Show Completed" disableMargin />
          <Switch
            defaultChecked={showCompleted}
            onChange={() => setShowCompleted((prev) => !prev)}
          />
        </Stack>
        <StyledSelect
          name="status"
          options={WORK_STATUS}
          defaultValue={state}
          fullWidth={false}
          required
        />
        <HubButton
          variant="outlined"
          size="xsmall"
          color="neutral"
          label="Close Work Order"
          onClick={onCloseWorkOrder}
        />
        <HubButton
          variant="contained"
          size="xsmall"
          label="Save Changes"
          type="submit"
          disabled={!isDirty}
        />
        <HubButton
          variant="contained"
          size="xsmall"
          color="neutral"
          icon="Download"
          label="Download"
          iconProps={{
            size: 14,
          }}
          onClick={handleDownload}
        />
      </Stack>
    </StyledTitleStack>
  );
};

export default WorkOrderBar;
